import React, { useEffect, useRef } from "react";
import Quill from "quill";

const TextEditor = ({ description, setTextContent, comment = false }) => {
  const editorRef = useRef(null);

  useEffect(() => {
    const options = {
      debug: "info",
      modules: {
        toolbar: true,
      },
      placeholder: comment ? "Add Comment..." : "Add Description...",
      theme: "snow",
    };
    const cleanedText =
      description && description.replace(/(?<!\n)\n(?!\n)/g, "");
    const quill = new Quill(editorRef.current, options);

    quill.on("text-change", () => {
      const typedText = quill.root.innerHTML;

      setTextContent(typedText);
    });

    quill.root.innerHTML = cleanedText;

    return () => {
      quill.off("text-change");
      quill.off("selection-change");
      quill.disable();
    };
  }, [description]);
  return <div id={comment ? "commentEditor" : "editor"} ref={editorRef}></div>;
};

export default TextEditor;
